import { isEmpty } from "lodash";
import { useCallback } from "react";
import { MenuProviderModel } from "../providers/menu-principal-provider/menu-principal-provider-model";
import { PedidosStorageKeys, useSaurusPedidosStorage } from "./saurus-pedidos-storage";

export function useMenuStorage() {
    const { getRegistro, setRegistro, delRegistro } = useSaurusPedidosStorage();

    const get = useCallback((): MenuProviderModel => {
        let menu = getRegistro(PedidosStorageKeys.ConfiguracoesMenu, false) as MenuProviderModel;
        if (isEmpty(menu)) {
            menu = {
                situacao: "Fechado",
                modelo: "Completo"
            };
            setRegistro(PedidosStorageKeys.ConfiguracoesMenu, menu, false);
        }
        return menu;
    }, [getRegistro, setRegistro]);

    const persist = useCallback((model: MenuProviderModel) => {
        if (model === undefined) {
            delRegistro(PedidosStorageKeys.ConfiguracoesMenu, false);
        } else {
            setRegistro(PedidosStorageKeys.ConfiguracoesMenu, model, false);
        }
    }, [delRegistro, setRegistro]);

    return {
        get,
        persist
    };
}
